/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type Address = {
  __typename?: 'Address';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  countryId?: Maybe<Scalars['String']>;
  customerId: Scalars['Int'];
  email?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  lastname?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  personalId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phonePrefix?: Maybe<Scalars['String']>;
  shipmentAddressId: Scalars['ID'];
  stateId?: Maybe<Scalars['String']>;
  vatCode?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type BundledOptions = {
  __typename?: 'BundledOptions';
  bundledProductItems?: Maybe<Array<Maybe<BundledProductItem>>>;
  isAbstractProduct?: Maybe<Scalars['Boolean']>;
  isMultiple?: Maybe<Scalars['Boolean']>;
  isOptional?: Maybe<Scalars['Boolean']>;
  type?: Maybe<BundledProductEnum>;
};

export enum BundledProductEnum {
  Abstract = 'abstract',
  Envelopes = 'envelopes',
  PaperType = 'paperType',
  PosterBindings = 'posterBindings',
  PrintAreas = 'printAreas',
  SpotFinishes = 'spotFinishes',
  Trims = 'trims'
}

export type BundledProductInfo = {
  __typename?: 'BundledProductInfo';
  abstractProductId?: Maybe<Scalars['Int']>;
  colorTypeId?: Maybe<Scalars['Int']>;
  internalUid?: Maybe<Scalars['String']>;
  paperFormatId?: Maybe<Scalars['Int']>;
  paperTypeId?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Int']>;
  productTypeId?: Maybe<Scalars['Int']>;
  productUid?: Maybe<Scalars['String']>;
};

export type BundledProductItem = {
  __typename?: 'BundledProductItem';
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDefaultSelected?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  previewUrl?: Maybe<Scalars['String']>;
  price?: Maybe<Price>;
  pricePerItem?: Maybe<Price>;
  productInfo?: Maybe<BundledProductInfo>;
  thumbnailUrl?: Maybe<Scalars['String']>;
};

export type Cart = {
  __typename?: 'Cart';
  analyticsData?: Maybe<Scalars['String']>;
  canProceedToCheckout?: Maybe<Scalars['Boolean']>;
  carts?: Maybe<Array<Maybe<CustomerOrder>>>;
  currencyId?: Maybe<Scalars['String']>;
  encMerchantReference?: Maybe<Scalars['String']>;
  hasFreeShippingForOptedInInNativeApp?: Maybe<Scalars['Boolean']>;
  paymentMethods?: Maybe<Array<Maybe<Scalars['String']>>>;
  priceInclVat?: Maybe<Scalars['String']>;
  showMessageAboutCustomsAndFees?: Maybe<Scalars['Boolean']>;
  totals?: Maybe<OrderTotals>;
  vouchers?: Maybe<Array<Maybe<Voucher>>>;
  warningCode?: Maybe<Scalars['String']>;
};

export type CustomerOpPlus = {
  __typename?: 'CustomerOpPlus';
  active_from?: Maybe<Scalars['String']>;
  active_until?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['Int']>;
  customer_op_plus_id: Scalars['ID'];
  is_active?: Maybe<Scalars['Boolean']>;
  is_subscription?: Maybe<Scalars['Boolean']>;
  order_id?: Maybe<Scalars['Int']>;
};

export type CustomerOrder = {
  __typename?: 'CustomerOrder';
  billingAddressId?: Maybe<Scalars['Int']>;
  currencyId?: Maybe<Scalars['String']>;
  customerId: Scalars['Int'];
  customerOrderId: Scalars['Int'];
  items?: Maybe<Array<Maybe<OrderItem>>>;
  shipmentAddressId?: Maybe<Scalars['Int']>;
  shippingMethodId?: Maybe<Scalars['Int']>;
  shippingMethodsInfo?: Maybe<Array<Maybe<ShippingMethodsInfo>>>;
  totals?: Maybe<OrderTotals>;
};

export type Design = {
  __typename?: 'Design';
  categoryId?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  designId: Scalars['Int'];
  encDesignId?: Maybe<Scalars['String']>;
  encParentDesignId?: Maybe<Scalars['String']>;
  extraParams?: Maybe<DesignExtraParams>;
  incompleteByDeviceGuid?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  orientationId?: Maybe<Scalars['Int']>;
  paperFormat?: Maybe<PaperFormat>;
  paperFormatId?: Maybe<Scalars['Int']>;
  parentDesign?: Maybe<Design>;
  parentDesignId?: Maybe<Scalars['Int']>;
  productTypeId?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type DesignExtraParams = {
  __typename?: 'DesignExtraParams';
  isPublicNonPersonalized?: Maybe<Scalars['String']>;
  posterEditorFunnel?: Maybe<Scalars['String']>;
  productDesignerEditorFunnel?: Maybe<Scalars['String']>;
};

export type DetailedPricesInfo = {
  __typename?: 'DetailedPricesInfo';
  price?: Maybe<PricePoint>;
  priceAccordingToVatOption?: Maybe<PricePoint>;
  priceIncVat?: Maybe<PricePoint>;
  pricePerItem?: Maybe<PricePoint>;
  pricePerItemAccordingToVatOption?: Maybe<PricePoint>;
  pricePerItemIncVat?: Maybe<PricePoint>;
  priceWithDiscountAccordingToVatOption?: Maybe<PricePoint>;
  productPriceSetId?: Maybe<Scalars['Int']>;
};

export type OrderItem = {
  __typename?: 'OrderItem';
  availableTypesToBundle?: Maybe<Array<Maybe<Scalars['Int']>>>;
  bundleOwnerOrderItemId?: Maybe<Scalars['Int']>;
  bundledOrderItemIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  childItems?: Maybe<Array<Maybe<OrderItem>>>;
  customerOrderId?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  design?: Maybe<Design>;
  designId?: Maybe<Scalars['Int']>;
  encOrderItemId?: Maybe<Scalars['String']>;
  hasOptions?: Maybe<Scalars['Boolean']>;
  isInBundle?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  optionValue?: Maybe<Scalars['String']>;
  orderItemId: Scalars['Int'];
  orderItemType?: Maybe<OrderItemType>;
  orderItemTypeId?: Maybe<Scalars['Int']>;
  previewUrl?: Maybe<Scalars['String']>;
  price?: Maybe<Price>;
  productBatchSize?: Maybe<ProductBatchSize>;
  productBatchSizeId?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  quantityOptions?: Maybe<QuantityOptionsInfo>;
  thumbnailUrl?: Maybe<Scalars['String']>;
};

export type OrderItemType = {
  __typename?: 'OrderItemType';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  orderItemTypeId: Scalars['Int'];
};

export type OrderTotals = {
  __typename?: 'OrderTotals';
  productDiscount?: Maybe<PricePoint>;
  productInitial?: Maybe<PricePoint>;
  productTotal?: Maybe<PricePoint>;
  productTotalVat?: Maybe<PricePoint>;
  shippingDiscount?: Maybe<PricePoint>;
  shippingInitial?: Maybe<PricePoint>;
  shippingTotal?: Maybe<PricePoint>;
  shippingTotalVat?: Maybe<PricePoint>;
  total?: Maybe<PricePoint>;
  totalDiscount?: Maybe<PricePoint>;
  totalInitial?: Maybe<PricePoint>;
  totalVat?: Maybe<PricePoint>;
};

export type PaperFormat = {
  __typename?: 'PaperFormat';
  description?: Maybe<Scalars['String']>;
  finalHeight?: Maybe<Scalars['Int']>;
  finalSize?: Maybe<Scalars['String']>;
  finalWidth?: Maybe<Scalars['Int']>;
  foldingType?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  isFolded?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  orientationId?: Maybe<Scalars['Int']>;
  paperFormatGroupId?: Maybe<Scalars['Int']>;
  paperFormatId: Scalars['Int'];
  size?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type Price = {
  __typename?: 'Price';
  discount?: Maybe<PricePoint>;
  initial?: Maybe<PricePoint>;
  total?: Maybe<PricePoint>;
};

export type PricePoint = {
  __typename?: 'PricePoint';
  currencyId?: Maybe<Scalars['String']>;
  formatted?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type Product = {
  __typename?: 'Product';
  inStock?: Maybe<Scalars['Boolean']>;
  paperFormatId?: Maybe<Scalars['Int']>;
  productId: Scalars['Int'];
  productTypeId?: Maybe<Scalars['Int']>;
};

export type ProductBatchSize = {
  __typename?: 'ProductBatchSize';
  product?: Maybe<Product>;
  productBatchSizeId: Scalars['Int'];
  productId?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Int']>;
};

export type QuantityOption = {
  __typename?: 'QuantityOption';
  batchName?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  prices?: Maybe<DetailedPricesInfo>;
  quantity?: Maybe<Scalars['Int']>;
};

export type QuantityOptionsInfo = {
  __typename?: 'QuantityOptionsInfo';
  categoryId?: Maybe<Scalars['Int']>;
  colorTypeId?: Maybe<Scalars['Int']>;
  currencyId?: Maybe<Scalars['String']>;
  paperFormatId?: Maybe<Scalars['Int']>;
  paperTypeId?: Maybe<Scalars['Int']>;
  productBatchSizeId?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Int']>;
  productTypeId?: Maybe<Scalars['Int']>;
  quantityOptions?: Maybe<Array<Maybe<QuantityOption>>>;
  weight?: Maybe<Scalars['Float']>;
};

export type Query = {
  __typename?: 'Query';
  bundled_options_query?: Maybe<Array<Maybe<BundledOptions>>>;
  cart_query?: Maybe<Cart>;
};


export type QueryBundled_Options_QueryArgs = {
  orderItemId: Scalars['Int'];
};


export type QueryCart_QueryArgs = {
  channel?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['Int']>;
};

export type ShippingMethod = {
  __typename?: 'ShippingMethod';
  id: Scalars['Int'];
  isPhoneRequired?: Maybe<Scalars['Boolean']>;
  lastOrderDateStatus?: Maybe<Scalars['Int']>;
  maxDeliveryDate?: Maybe<Scalars['String']>;
  minDeliveryDate?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Price>;
  serviceType?: Maybe<Scalars['String']>;
  showMessageAboutCustomsAndFees?: Maybe<Scalars['Boolean']>;
};

export type ShippingMethodsInfo = {
  __typename?: 'ShippingMethodsInfo';
  countryFlag: Scalars['String'];
  countryId: Scalars['String'];
  countryName: Scalars['String'];
  shippingMethods?: Maybe<Array<Maybe<ShippingMethod>>>;
  supportPageUrl: Scalars['String'];
};

export type Voucher = {
  __typename?: 'Voucher';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Float']>;
  expiration?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type BasketQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type BasketQueryQuery = { __typename?: 'Query', cart_query?: { __typename?: 'Cart', carts?: Array<{ __typename?: 'CustomerOrder', customerOrderId: number, customerId: number, currencyId?: string | null, shipmentAddressId?: number | null, items?: Array<{ __typename?: 'OrderItem', name?: string | null, description?: string | null, orderItemId: number, quantity?: number | null, designId?: number | null, thumbnailUrl?: string | null, previewUrl?: string | null, price?: { __typename?: 'Price', initial?: { __typename?: 'PricePoint', formatted?: string | null } | null, discount?: { __typename?: 'PricePoint', formatted?: string | null } | null, total?: { __typename?: 'PricePoint', formatted?: string | null } | null } | null, quantityOptions?: { __typename?: 'QuantityOptionsInfo', quantityOptions?: Array<{ __typename?: 'QuantityOption', quantity?: number | null, isDefault?: boolean | null, batchName?: string | null, prices?: { __typename?: 'DetailedPricesInfo', price?: { __typename?: 'PricePoint', value?: number | null, formatted?: string | null, currencyId?: string | null } | null, priceWithDiscountAccordingToVatOption?: { __typename?: 'PricePoint', value?: number | null, formatted?: string | null, currencyId?: string | null } | null } | null } | null> | null } | null } | null> | null } | null> | null, totals?: { __typename?: 'OrderTotals', productInitial?: { __typename?: 'PricePoint', value?: number | null, formatted?: string | null, currencyId?: string | null } | null, productDiscount?: { __typename?: 'PricePoint', value?: number | null, formatted?: string | null, currencyId?: string | null } | null, productTotal?: { __typename?: 'PricePoint', value?: number | null, formatted?: string | null, currencyId?: string | null } | null, shippingInitial?: { __typename?: 'PricePoint', value?: number | null, formatted?: string | null, currencyId?: string | null } | null, shippingDiscount?: { __typename?: 'PricePoint', value?: number | null, formatted?: string | null, currencyId?: string | null } | null, shippingTotal?: { __typename?: 'PricePoint', value?: number | null, formatted?: string | null, currencyId?: string | null } | null, totalInitial?: { __typename?: 'PricePoint', value?: number | null, formatted?: string | null, currencyId?: string | null } | null, totalDiscount?: { __typename?: 'PricePoint', value?: number | null, formatted?: string | null, currencyId?: string | null } | null, total?: { __typename?: 'PricePoint', value?: number | null, formatted?: string | null, currencyId?: string | null } | null, totalVat?: { __typename?: 'PricePoint', value?: number | null, formatted?: string | null, currencyId?: string | null } | null, productTotalVat?: { __typename?: 'PricePoint', value?: number | null, formatted?: string | null, currencyId?: string | null } | null, shippingTotalVat?: { __typename?: 'PricePoint', value?: number | null, formatted?: string | null, currencyId?: string | null } | null } | null } | null };

export type BundledProductsQueryVariables = Exact<{
  orderItemId: Scalars['Int'];
}>;


export type BundledProductsQuery = { __typename?: 'Query', bundled_options_query?: Array<{ __typename?: 'BundledOptions', type?: BundledProductEnum | null, isMultiple?: boolean | null, isOptional?: boolean | null, bundledProductItems?: Array<{ __typename?: 'BundledProductItem', id?: number | null, name?: string | null, description?: string | null, iconUrl?: string | null, thumbnailUrl?: string | null, isDefaultSelected?: boolean | null, price?: { __typename?: 'Price', initial?: { __typename?: 'PricePoint', formatted?: string | null } | null, discount?: { __typename?: 'PricePoint', formatted?: string | null } | null, total?: { __typename?: 'PricePoint', formatted?: string | null } | null } | null } | null> | null } | null> | null };


export const BasketQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BasketQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cart_query"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}},{"kind":"Field","name":{"kind":"Name","value":"shipmentAddressId"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"orderItemId"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"designId"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatted"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewUrl"}},{"kind":"Field","name":{"kind":"Name","value":"quantityOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantityOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"batchName"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceWithDiscountAccordingToVatOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productInitial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingInitial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalInitial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalVat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productTotalVat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingTotalVat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BasketQueryQuery, BasketQueryQueryVariables>;
export const BundledProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BundledProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderItemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bundled_options_query"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderItemId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isMultiple"}},{"kind":"Field","name":{"kind":"Name","value":"isOptional"}},{"kind":"Field","name":{"kind":"Name","value":"bundledProductItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"iconUrl"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultSelected"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatted"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BundledProductsQuery, BundledProductsQueryVariables>;